module.exports = __webpack_public_path__ + "media/images/banner_lov_it-ddff3e43078bb7cb1bff51709a1bbbf9.png";